// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__EHBFL","item":"List_item__LMBx4"};